import { createActions } from '~/store/utils';

const { Types, Actions } = createActions({
  // logout
  LOGOUT_REQUEST: null,
  LOGOUT_SUCCESS: null,
  LOGOUT_FAILURE: null,
  LOGOUT_ERROR: null,
});

export { Actions, Types };
